// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../../shared/reducers/busy-counter';
import claim from './claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import openMaintenancePlans from './open-maintenance-plans';
import openServiceIntervals from './open-service-intervals';
import product from './product-details';
import selectedOpenMaintenancePlan from './selected-open-maintenance-plan';
import showNoResultsFound from './show-no-results-found';
import temporaryObjectKey from './temporary-object-key';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    formValidation,
    isActionButtonDisabled,
    isEditable,
    isStickyHeaderVisible,
    openMaintenancePlans,
    openServiceIntervals,
    product,
    selectedOpenMaintenancePlan,
    showNoResultsFound,
    temporaryObjectKey,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/index.js